import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import t from '../../../utils/translate';
import { TabTypes } from '../../../constants/user-groups-constants';
import React from 'react';

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return <div role="tabpanel" hidden={value !== index} {...other}></div>;
}

/**
 * Creates a tabs system with USERS and GROUPS.
 * @param {number} currentTab
 * @param {Function} handleTabChange
 * @param usersTabDisabled
 * @param groupsTabDisabled
 * @return {JSX.Element}
 * @constructor
 */

export default function ContactsTabsSystem({ currentTab, handleTabChange, usersTabDisabled, groupsTabDisabled }) {
    return (
        <Box className="tabs-box-container" sx={{ width: '100%' }}>
            <Box className="tabs-box-content" sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                    className="tabs-container"
                    value={currentTab}
                    onChange={(event, selectedTab) => handleTabChange(selectedTab)}
                >
                    <Tab
                        className="tab-item"
                        label={t('js_all_users')}
                        disabled={usersTabDisabled === true}
                        data-test-id="all-users-tab"
                    />
                    <Tab
                        className="tab-item"
                        label={t('js_all_groups')}
                        disabled={groupsTabDisabled === true}
                        data-test-id="all-groups-tab"
                    />
                </Tabs>
            </Box>
            <CustomTabPanel value={currentTab} index={TabTypes.USERS_TAB}></CustomTabPanel>
            <CustomTabPanel value={currentTab} index={TabTypes.GROUPS_TAB}></CustomTabPanel>
        </Box>
    );
}
